"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uuid_1 = require("uuid");
const styles_1 = require("./styles");
exports.GridList = (0, react_1.forwardRef)(({ gap, items, rowHeight, gridTemplateColumns, wrapperOffsetRight, }) => {
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledGrid, { items: items, gap: gap, rowHeight: rowHeight, gridTemplateColumns: gridTemplateColumns, wrapperOffsetRight: wrapperOffsetRight, children: items.map(item => ((0, jsx_runtime_1.jsx)(styles_1.StyledGridItem, { ...(item.alignItems && { alignItems: item.alignItems }), ...(item.justifyContent && { justifyContent: item.justifyContent }), children: item.content }, (0, uuid_1.v4)()))) }));
});
exports.GridList.displayName = 'GridList';
exports.default = exports.GridList;
//# sourceMappingURL=grid-list.js.map